import { SpinResultData } from "@lib/titan2-slingo/dist/api/model/data/SpinResultData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ExtendedReelSequenceData } from "./ExtendedReelSequenceData";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { ExtendedSymbolWinData } from "./ExtendedSymbolWinData";
import { ApiConstants } from "../enum/Constants";
/**
 * ExtendedSpinResultData.ts
 */
export class ExtendedSpinResultData extends SpinResultData {
    constructor(data) {
        super(data);
    }
    getCumulativeWildScatterMultiplier() {
        return this.cumulativeWildScatterMultiplier;
    }
    getCumulativeCoinMultiplier() {
        return this.cumulativeCoinMultiplier;
    }
    solidifyCumulativeMultipliers() {
        this.cumulativeCoinMultiplier = 0;
        this.cumulativeWildScatterMultiplier = 0;
        const feature = this.data.getDataObject(SlingoConstants.PROPERTY_FEATURE);
        if (feature) {
            const jokerMultipliers = feature.getNumber(ApiConstants.PROPERTY_JOKER_MULTIPLIERS);
            const superJokerMultipliers = feature.getNumber(ApiConstants.PROPERTY_SUPER_JOKER_MULTIPLIERS);
            if (jokerMultipliers !== undefined) {
                this.cumulativeWildScatterMultiplier += jokerMultipliers;
            }
            if (superJokerMultipliers !== undefined) {
                this.cumulativeWildScatterMultiplier += superJokerMultipliers;
            }
            const coinMultipliers = feature.getNumber(ApiConstants.PROPERTY_COIN_MULTIPLIERS);
            if (coinMultipliers !== undefined) {
                this.cumulativeCoinMultiplier = coinMultipliers;
            }
        }
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyCumulativeMultipliers();
            this.solidifySpinType();
        }
    }
    solidifySpinType() {
        let spinType = this.data.getString(ApiConstants.PROPERTY_SPIN_TYPE);
        if (spinType) {
            this.spinType = spinType;
        }
    }
    solidifyReelSequence() {
        let reelSequenceData = this.data.getDataObject(SlingoConstants.PROPERTY_REEL_SEQUENCE);
        if (reelSequenceData) {
            this.reelSequence = new ExtendedReelSequenceData(reelSequenceData);
        }
    }
    solidifySymbolWins() {
        let symbolWinArray = this.data.getDataArray(SlingoConstants.PROPERTY_SYMBOL_WINS);
        this.symbolWins = new Dictionary();
        if (symbolWinArray) {
            for (let i = 0; i < symbolWinArray.length; i++) {
                let win = new ExtendedSymbolWinData(symbolWinArray[i]);
                this.symbolWins.setValue(win.getType(), win);
            }
        }
    }
    wasFreeSpin() {
        return this.spinType === "FREE";
    }
}
//# sourceMappingURL=ExtendedSpinResultData.js.map